import { useReduxSelector } from '../../../hooks';
import { rootStateBranchSelector } from '../../../utils/rootStateBranchSelector';
import type { TUserData } from '../slice';

export const userSelector = rootStateBranchSelector('user');

export function useUserSelector(): TUserData {
  return useReduxSelector(userSelector);
}
